export default "__VITE_ASSET__DRTP8tsd__"